import { createRoutine } from 'redux-saga-routines';
import AdditionalDocumentsConstants from 'spa/constants/AdditionalDocumentsConstants';

export const loadDocuments = createRoutine(AdditionalDocumentsConstants.LOAD_DOCUMENTS);
export const submitDocument = createRoutine(AdditionalDocumentsConstants.SUBMIT_DOCUMENT);
export const submitDocumentForm = createRoutine(AdditionalDocumentsConstants.FORM);
